import topic from 'components/help/topic';
import Help from './Help';

export default {
  path: 'help',

  getChildRoutes(location, cb) {
    cb(null, [topic]);
  },

  getComponents(location, cb) {
    cb(null, Help);
  },
};
